import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { PermissionsState } from '@osos/shared/legacy-core';
import { ComponentBase } from '@osos/shared/utility';
import { takeUntil } from 'rxjs';
import { skip } from 'rxjs/operators';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
  standalone: false,
})
export class NoAccessComponent extends ComponentBase implements OnInit {
  isPublicAccessForbidden;
  availableSpaces: {
    spaceName: string;
    spaceIcon: string;
    fullUrl: string;
  }[] = [];

  //When the 403 is produced by view we need to sent the following data
  constructor(private store: Store) {
    super();
  }

  ngOnInit(): void {
    const state = history.state;
    if (state) {
      this.isPublicAccessForbidden = state.isPublicAccessForbidden || false;
      this.availableSpaces = state.availableSpaces || [];
    }

    if (state?.isPublicAccessForbidden) {
      this.store
        .select(PermissionsState.getUserAuthenticatedViewsCount)
        .pipe(skip(1), takeUntil(this.destroy$))
        .subscribe((count) => {
          this.isPublicAccessForbidden = count > 0;
        });
    } else {
      this.isPublicAccessForbidden = false;
    }
  }

  navigateToSpace(url: string): void {
    window.location.href = `https://${url}`;
  }

  trackByFn(index: number, item: any): number {
    return item.id + index;
  }
}
